import { BlockProps } from "../../containers/Block";

export default function Geolocation({ block }: BlockProps) {
  return <div>Geolocation - {block.blockId}</div>;
}
